/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-04 14:55:01                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-14 12:02:31                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * CustomerInfoCard: display customer entity informations
*/

/* Imports */
import { Card, CardBody, Typography } from "@material-tailwind/react";
import { EnvelopeIcon, MapPinIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
/***/

/* Components */
import AddressDisplay from "../address/AddressDisplay";
/***/

/**
* CustomerInfoCard: display customer entity informations
* @param customer - customer data
*/
export default function CustomerInfoCard({
  customer,
  onClick,
  onClear
}: {
  customer: EasyTech.Customer,
  onClick?: () => void,
  onClear?: () => void
}) {
  return (
    <Card className="m-3 shadow-none border rounded-lg border-gray-300 relative" onClick={onClick}>
      {onClear && (
        <button
          type="button"
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
          onClick={(event) => {
            event.stopPropagation();
            onClear();
          }}
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      )}
      <CardBody className="flex flex-col gap-1">
        <Typography variant={"h6"} className="mb-2 pr-6">
          { customer.name }
        </Typography>

        {customer.address && (
          <div className="flex gap-2">
            <div className="flex items-center justify-center">
              <MapPinIcon className="h-[20px] w-[20px] text-gray-400"/>
            </div>
            
            <AddressDisplay address={customer.address}/>
          </div>
        )}

        <div className="flex gap-2">
          <div className="flex items-center justify-center">
            <EnvelopeIcon className="h-[20px] w-[20px] text-gray-400"/>
          </div>

          <Typography>
            {customer.contactInfo && customer.contactInfo.email ? customer.contactInfo.email : t("common:noEmail")}
          </Typography>
        </div>
        
        <div className="flex gap-2">
          <div className="flex items-center justify-center">
            <PhoneIcon className="h-[20px] w-[20px] text-gray-400"/>
          </div>

          <Typography>
            {customer.contactInfo && customer.contactInfo.phone ?  customer.contactInfo.phone : t("common:noPhone")}
          </Typography>
        </div>

      </CardBody>
    </Card>
  );
}
/***/
